import React from "react";
import EditTwoTone from "@ant-design/icons/es/icons/EditTwoTone";
import DeleteTwoTone from "@ant-design/icons/es/icons/DeleteTwoTone";
import {stringColumn} from "../../../../helpers/commonColumns";
import {Tag, Tooltip} from "antd";
import DataType from "../../../../constants/DataType";
import InputDebounce from "../../../../components/InputDebounce";
import {DeleteOutlined} from "@ant-design/icons";
import GridActionIcon from "../../../../components/GridActionIcon";
import EditOutlined from "@ant-design/icons/es/icons/EditOutlined";
import InfoCircleTwoTone from "@ant-design/icons/es/icons/InfoCircleTwoTone";
import InfoCircleOutlined from "@ant-design/icons/es/icons/InfoCircleOutlined";
import moment from "../../../../components/GenericCrudPage/GenericCrudPage";

const companyColumns = ({
                            primaryColor, onEditClick, onDeleteClick, onLicencesClick,
                            toggleCompanyDetails, companyDetailsVisible, onRemoveProductFromCompany, updateFiltersMap
                        }) => {

    const actionColumnWidth = 3 * 55;
    const twoToneColor = primaryColor;

    const getActionsItems = record => {

        const actionsItems = [];

        actionsItems.push(<GridActionIcon key="edit" title="Edit"
                                          icon={<EditTwoTone twoToneColor={twoToneColor}/>}
                                          darkIcon={<EditOutlined/>}
                                          onClick={() => {
                                              onEditClick(record)
                                          }}/>);

        actionsItems.push(<GridActionIcon key="delete" title="Delete"
                                          icon={<DeleteTwoTone twoToneColor={twoToneColor}/>}
                                          darkIcon={<DeleteOutlined/>}
                                          onClick={() => {
                                              onDeleteClick(record)
                                          }}/>);

        actionsItems.push(<GridActionIcon key="details" title="Details"
                                          icon={<InfoCircleTwoTone twoToneColor={twoToneColor}/>}
                                          darkIcon={<InfoCircleOutlined/>}
                                          onClick={() => {
                                              toggleCompanyDetails(!companyDetailsVisible, record)
                                          }}/>);

        // actionsItems.push(<GridActionIcon
        //     key="licences"
        //     title='Licences'
        //     icon={<CopyrightTwoTone twoToneColor={twoToneColor}/>}
        //     darkIcon={<DatabaseOutlined/>}
        //     onClick={() => {
        //         onLicencesClick(record);
        //     }}/>);

        return actionsItems;

    };

    let actions = {
        title: 'Actions',
        key: 'action',
        width: actionColumnWidth,
        render: (text, record) => (
            <span>{getActionsItems(record)}</span>
        )
    };

    return [
        stringColumn('companyName', () => {
            return (
                <div>
                    <div><span>Company Name</span></div>
                    <div onClick={(e) => e.stopPropagation()} style={{paddingTop: 5}}>
                        <InputDebounce allowClear={true} style={{width: '90%'}} onChange={(e) => {
                            updateFiltersMap('companyName', DataType.TEXT, e.target.value);
                        }}/>
                    </div>
                </div>
            )
        }),
        stringColumn('email', () => {
            return (
                <div>
                    <div><span>Responsible Email</span></div>
                    <div onClick={(e) => e.stopPropagation()} style={{paddingTop: 5}}>
                        <InputDebounce allowClear={true} style={{width: '90%'}} onChange={(e) => {
                            updateFiltersMap('email', DataType.TEXT, e.target.value);
                        }}/>
                    </div>
                </div>
            )
        }),
        stringColumn('telephone', () => {
            return (
                <div>
                    <div><span>Phone</span></div>
                    <div onClick={(e) => e.stopPropagation()} style={{paddingTop: 5}}>
                        <InputDebounce allowClear={true} style={{width: '90%'}} onChange={(e) => {
                            updateFiltersMap('telephone', DataType.TEXT, e.target.value);
                        }}/>
                    </div>
                </div>
            )
        }),
        stringColumn('country', () => {
            return (
                <div>
                    <div><span>Country</span></div>
                    <div onClick={(e) => e.stopPropagation()} style={{paddingTop: 5}}>
                        <InputDebounce allowClear={true} style={{width: '90%'}} onChange={(e) => {
                            updateFiltersMap('country', DataType.TEXT, e.target.value);
                        }}/>
                    </div>
                </div>
            )
        }),
        {
            key: 'softwareProducts',
            dataIndex: 'softwareProducts',
            title: () => {
                return (
                    <div>
                        <div><span>Software Products</span></div>
                    </div>
                )
            },
            render: (softwareProducts, {companyName}) => {
                return <>
                    {
                        softwareProducts.map(({
                                                  companyHasSoftwareProductId, softwareProductCode, companyHasSoftwareProductCode, softwareProductName, deleteActionEnabled
                                              }) =>
                            <Tag closable={deleteActionEnabled}
                                 className='software-product-tag'
                                 key={companyHasSoftwareProductId}
                                 closeIcon={<Tooltip
                                     title={`Remove ${softwareProductCode} from ${companyName}`}><DeleteOutlined/></Tooltip>}
                                 onClose={(e) => {
                                     e.preventDefault();
                                     onRemoveProductFromCompany({
                                         companyName,
                                         companyHasSoftwareProductId,
                                         softwareProductCode,
                                         softwareProductName
                                     })
                                 }}>
                                {companyHasSoftwareProductCode}
                            </Tag>)
                    }
                </>;
            }
        },
        actions
    ]
};

export default companyColumns;